/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../instant_access_program_model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "inflows": {
        "nested": {
          "service": {
            "nested": {
              "InstantAccessError": {
                "values": {
                  "INSTANT_ACCESS_ERROR_DO_NOT_USE": 0,
                  "GENERIC_INSTANT_ACCESS_ERROR": 1,
                  "INSTANT_ACCESS_PROGRAM_NOT_FOUND": 2
                }
              },
              "GlyphIcon": {
                "values": {
                  "DO_NOT_USE_GLYPH_ICON": 0,
                  "DOORDASH": 5,
                  "UBER_EATS": 6,
                  "GRUBHUB": 7
                }
              },
              "PillDescription": {
                "fields": {
                  "text": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "icon": {
                    "type": ".squareup.inflows.service.GlyphIcon",
                    "id": 2,
                    "rule": "optional"
                  },
                  "variant": {
                    "type": ".squareup.inflows.service.PillDescription.PillVariant",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": "PILL_VARIANT_DEFERRED"
                    }
                  },
                  "size": {
                    "type": ".squareup.inflows.service.PillDescription.PillSize",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": "PILL_SIZE_DEFERRED"
                    }
                  }
                },
                "nested": {
                  "PillVariant": {
                    "values": {
                      "PILL_VARIANT_DEFERRED": 0,
                      "PILL_VARIANT_NORMAL": 1,
                      "PILL_VARIANT_EMPHASIS": 2,
                      "PILL_VARIANT_SUCCESS": 3,
                      "PILL_VARIANT_WARNING": 4
                    }
                  },
                  "PillSize": {
                    "values": {
                      "PILL_SIZE_DEFERRED": 0,
                      "PILL_SIZE_NORMAL": 1
                    }
                  }
                }
              },
              "InstantAccessRequirementItem": {
                "fields": {
                  "type": {
                    "type": ".squareup.inflows.service.InstantAccessRequirementItem.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isDisabled": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "INSTANT_ACCESS_REQUIREMENT_ITEM_TYPE_DO_NOT_USE": 0,
                      "ACTIVE_CHECKING_ACCOUNT": 1,
                      "DIRECT_DEPOSITS_SETUP": 2,
                      "ORDERS_INTEGRATION_SETUP": 3,
                      "DEACTIVATE_INSTANT_PAYOUTS": 4,
                      "REACTIVATE_INSTANT_PAYOUTS": 5
                    }
                  }
                }
              },
              "InstantAccessAccordionItem": {
                "fields": {
                  "platformLabel": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "logoImageUrl": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "logoImageBackgroundColorCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "pillDescription": {
                    "type": ".squareup.inflows.service.PillDescription",
                    "id": 4,
                    "rule": "optional"
                  },
                  "requirementItems": {
                    "type": ".squareup.inflows.service.InstantAccessRequirementItem",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "isDisabled": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.inflows.service.InstantAccessAccordionItem.Status",
                    "id": 7,
                    "rule": "optional"
                  },
                  "platform": {
                    "type": ".squareup.inflows.InstantAccessProgram.Platform",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "INSTANT_ACCESS_ACCORDION_ITEM_STATUS_DO_NOT_USE": 0,
                      "GET_STARTED": 1,
                      "COMING_SOON": 2,
                      "IN_PROGRESS": 3,
                      "ACTIVE": 4,
                      "CANCELING": 5
                    }
                  }
                }
              },
              "OnboardToInstantAccessRequest": {
                "fields": {
                  "optInMechanism": {
                    "type": ".squareup.inflows.InstantAccessProgram.OptInMechanism",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unitTokens": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "OnboardToInstantAccessResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.inflows.service.OnboardToInstantAccessResponse.Success",
                    "id": 1
                  },
                  "failure": {
                    "type": ".squareup.inflows.service.OnboardToInstantAccessResponse.Failure",
                    "id": 2
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {}
                  },
                  "Failure": {
                    "fields": {
                      "errors": {
                        "type": ".squareup.inflows.service.InstantAccessError",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "result": {
                    "oneof": ["success", "failure"]
                  }
                }
              },
              "RetrieveInstantAccessRequirementsStateRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveInstantAccessRequirementsStateResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.inflows.service.RetrieveInstantAccessRequirementsStateResponse.Success",
                    "id": 1
                  },
                  "failure": {
                    "type": ".squareup.inflows.service.RetrieveInstantAccessRequirementsStateResponse.Failure",
                    "id": 2
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {
                      "accordionItems": {
                        "type": ".squareup.inflows.service.InstantAccessAccordionItem",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "optedIn": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "Failure": {
                    "fields": {
                      "errors": {
                        "type": ".squareup.inflows.service.InstantAccessError",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "result": {
                    "oneof": ["success", "failure"]
                  }
                }
              },
              "ListDDSEligibleUnitsRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DDSEligibleUnitInfo": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "integrationToOptInStatus": {
                    "type": ".squareup.inflows.service.DDSEligibleUnitInfo.IntegrationToOptInStatus",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "IntegrationToOptInStatus": {
                    "fields": {
                      "platform": {
                        "type": ".squareup.inflows.InstantAccessProgram.Platform",
                        "id": 1,
                        "rule": "optional"
                      },
                      "isOptedIn": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ListDDSEligibleUnitsResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.inflows.service.ListDDSEligibleUnitsResponse.Success",
                    "id": 1
                  },
                  "failure": {
                    "type": ".squareup.inflows.service.ListDDSEligibleUnitsResponse.Failure",
                    "id": 2
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {
                      "units": {
                        "type": ".squareup.inflows.service.DDSEligibleUnitInfo",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "Failure": {
                    "fields": {
                      "errors": {
                        "type": ".squareup.inflows.service.InstantAccessError",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "result": {
                    "oneof": ["success", "failure"]
                  }
                }
              },
              "OptOutOfInstantAccessProgramRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "platform": {
                    "type": ".squareup.inflows.InstantAccessProgram.Platform",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "OptOutOfInstantAccessProgramResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.inflows.service.OptOutOfInstantAccessProgramResponse.Success",
                    "id": 1
                  },
                  "failure": {
                    "type": ".squareup.inflows.service.OptOutOfInstantAccessProgramResponse.Failure",
                    "id": 2
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {}
                  },
                  "Failure": {
                    "fields": {
                      "errors": {
                        "type": ".squareup.inflows.service.InstantAccessError",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "result": {
                    "oneof": ["success", "failure"]
                  }
                }
              },
              "OptInToInstantAccessProgramRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "platform": {
                    "type": ".squareup.inflows.InstantAccessProgram.Platform",
                    "id": 2,
                    "rule": "optional"
                  },
                  "optInMechanism": {
                    "type": ".squareup.inflows.InstantAccessProgram.OptInMechanism",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "OptInToInstantAccessProgramResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.inflows.service.OptInToInstantAccessProgramResponse.Success",
                    "id": 1
                  },
                  "failure": {
                    "type": ".squareup.inflows.service.OptInToInstantAccessProgramResponse.Failure",
                    "id": 2
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {
                      "instantAccessProgram": {
                        "type": ".squareup.inflows.InstantAccessProgram",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "Failure": {
                    "fields": {
                      "errors": {
                        "type": ".squareup.inflows.service.InstantAccessError",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "result": {
                    "oneof": ["success", "failure"]
                  }
                }
              },
              "ExternalInstantAccessService": {
                "methods": {
                  "OnboardToInstantAccess": {
                    "requestType": ".squareup.inflows.service.OnboardToInstantAccessRequest",
                    "responseType": ".squareup.inflows.service.OnboardToInstantAccessResponse"
                  },
                  "RetrieveInstantAccessRequirementsState": {
                    "requestType": ".squareup.inflows.service.RetrieveInstantAccessRequirementsStateRequest",
                    "responseType": ".squareup.inflows.service.RetrieveInstantAccessRequirementsStateResponse"
                  },
                  "ListDDSEligibleUnits": {
                    "requestType": ".squareup.inflows.service.ListDDSEligibleUnitsRequest",
                    "responseType": ".squareup.inflows.service.ListDDSEligibleUnitsResponse"
                  },
                  "OptOutOfInstantAccessProgram": {
                    "requestType": ".squareup.inflows.service.OptOutOfInstantAccessProgramRequest",
                    "responseType": ".squareup.inflows.service.OptOutOfInstantAccessProgramResponse"
                  },
                  "OptInToInstantAccessProgram": {
                    "requestType": ".squareup.inflows.service.OptInToInstantAccessProgramRequest",
                    "responseType": ".squareup.inflows.service.OptInToInstantAccessProgramResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.InstantAccessError && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.GlyphIcon && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.PillDescription && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.PillDescription?.nested?.PillVariant && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.PillDescription?.nested?.PillSize && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.InstantAccessRequirementItem && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.InstantAccessRequirementItem?.nested?.Type && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.InstantAccessAccordionItem && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.InstantAccessAccordionItem?.nested?.Status && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OnboardToInstantAccessRequest && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OnboardToInstantAccessResponse && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OnboardToInstantAccessResponse?.nested?.Success && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OnboardToInstantAccessResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.RetrieveInstantAccessRequirementsStateRequest && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.RetrieveInstantAccessRequirementsStateResponse && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.RetrieveInstantAccessRequirementsStateResponse?.nested?.Success && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.RetrieveInstantAccessRequirementsStateResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.ListDDSEligibleUnitsRequest && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.DDSEligibleUnitInfo && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.DDSEligibleUnitInfo?.nested?.IntegrationToOptInStatus && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.ListDDSEligibleUnitsResponse && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.ListDDSEligibleUnitsResponse?.nested?.Success && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.ListDDSEligibleUnitsResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OptOutOfInstantAccessProgramRequest && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OptOutOfInstantAccessProgramResponse && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OptOutOfInstantAccessProgramResponse?.nested?.Success && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OptOutOfInstantAccessProgramResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OptInToInstantAccessProgramRequest && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OptInToInstantAccessProgramResponse && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OptInToInstantAccessProgramResponse?.nested?.Success && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.OptInToInstantAccessProgramResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.inflows?.nested?.service?.nested?.ExternalInstantAccessService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE InstantAccessError @ squareup/inflows/service/external_instant_access_service.proto at 13:1
 */
export const InstantAccessError = $root.lookupEnum('squareup.inflows.service.InstantAccessError').values;
/**
 * SOURCE GlyphIcon @ squareup/inflows/service/external_instant_access_service.proto at 19:1
 */
export const GlyphIcon = $root.lookupEnum('squareup.inflows.service.GlyphIcon').values;
/**
 * Configuration for a pill element.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=127056-293706&t=WyErUcd04HTzDkYR-4">Market - Pill</a>
 *
 * SOURCE PillDescription @ squareup/inflows/service/external_instant_access_service.proto at 38:1
 */
export const PillDescription = $root.lookupType('squareup.inflows.service.PillDescription');
fixType(PillDescription, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PillDescription);
/**
 * SOURCE PillVariant @ squareup/inflows/service/external_instant_access_service.proto at 44:3
 */
PillDescription.PillVariant = $root.lookupEnum('squareup.inflows.service.PillDescription.PillVariant').values;
/**
 * SOURCE PillSize @ squareup/inflows/service/external_instant_access_service.proto at 52:3
 */
PillDescription.PillSize = $root.lookupEnum('squareup.inflows.service.PillDescription.PillSize').values;
/**
 * SOURCE InstantAccessRequirementItem @ squareup/inflows/service/external_instant_access_service.proto at 58:1
 */
export const InstantAccessRequirementItem = $root.lookupType('squareup.inflows.service.InstantAccessRequirementItem');
fixType(InstantAccessRequirementItem, {
  type: {
    required: true
  }
});
Builder.createAndAttachToType(InstantAccessRequirementItem);
/**
 * SOURCE Type @ squareup/inflows/service/external_instant_access_service.proto at 59:3
 */
InstantAccessRequirementItem.Type = $root.lookupEnum('squareup.inflows.service.InstantAccessRequirementItem.Type').values;
/**
 * SOURCE InstantAccessAccordionItem @ squareup/inflows/service/external_instant_access_service.proto at 86:1
 */
export const InstantAccessAccordionItem = $root.lookupType('squareup.inflows.service.InstantAccessAccordionItem');
fixType(InstantAccessAccordionItem);
Builder.createAndAttachToType(InstantAccessAccordionItem);
/**
 * SOURCE Status @ squareup/inflows/service/external_instant_access_service.proto at 87:3
 */
InstantAccessAccordionItem.Status = $root.lookupEnum('squareup.inflows.service.InstantAccessAccordionItem.Status').values;
/**
 * SOURCE OnboardToInstantAccessRequest @ squareup/inflows/service/external_instant_access_service.proto at 114:1
 */
export const OnboardToInstantAccessRequest = $root.lookupType('squareup.inflows.service.OnboardToInstantAccessRequest');
fixType(OnboardToInstantAccessRequest, {
  optInMechanism: {
    required: true
  }
});
Builder.createAndAttachToType(OnboardToInstantAccessRequest);
/**
 * SOURCE OnboardToInstantAccessResponse @ squareup/inflows/service/external_instant_access_service.proto at 120:1
 */
export const OnboardToInstantAccessResponse = $root.lookupType('squareup.inflows.service.OnboardToInstantAccessResponse');
fixType(OnboardToInstantAccessResponse);
Builder.createAndAttachToType(OnboardToInstantAccessResponse);
/**
 * SOURCE Success @ squareup/inflows/service/external_instant_access_service.proto at 126:3
 */
OnboardToInstantAccessResponse.Success = $root.lookupType('squareup.inflows.service.OnboardToInstantAccessResponse.Success');
fixType(OnboardToInstantAccessResponse.Success);
Builder.createAndAttachToType(OnboardToInstantAccessResponse.Success);
/**
 * SOURCE Failure @ squareup/inflows/service/external_instant_access_service.proto at 128:3
 */
OnboardToInstantAccessResponse.Failure = $root.lookupType('squareup.inflows.service.OnboardToInstantAccessResponse.Failure');
fixType(OnboardToInstantAccessResponse.Failure);
Builder.createAndAttachToType(OnboardToInstantAccessResponse.Failure);
/**
 * SOURCE RetrieveInstantAccessRequirementsStateRequest @ squareup/inflows/service/external_instant_access_service.proto at 133:1
 */
export const RetrieveInstantAccessRequirementsStateRequest = $root.lookupType('squareup.inflows.service.RetrieveInstantAccessRequirementsStateRequest');
fixType(RetrieveInstantAccessRequirementsStateRequest, {
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveInstantAccessRequirementsStateRequest);
/**
 * SOURCE RetrieveInstantAccessRequirementsStateResponse @ squareup/inflows/service/external_instant_access_service.proto at 137:1
 */
export const RetrieveInstantAccessRequirementsStateResponse = $root.lookupType('squareup.inflows.service.RetrieveInstantAccessRequirementsStateResponse');
fixType(RetrieveInstantAccessRequirementsStateResponse);
Builder.createAndAttachToType(RetrieveInstantAccessRequirementsStateResponse);
/**
 * SOURCE Success @ squareup/inflows/service/external_instant_access_service.proto at 143:3
 */
RetrieveInstantAccessRequirementsStateResponse.Success = $root.lookupType('squareup.inflows.service.RetrieveInstantAccessRequirementsStateResponse.Success');
fixType(RetrieveInstantAccessRequirementsStateResponse.Success);
Builder.createAndAttachToType(RetrieveInstantAccessRequirementsStateResponse.Success);
/**
 * SOURCE Failure @ squareup/inflows/service/external_instant_access_service.proto at 149:3
 */
RetrieveInstantAccessRequirementsStateResponse.Failure = $root.lookupType('squareup.inflows.service.RetrieveInstantAccessRequirementsStateResponse.Failure');
fixType(RetrieveInstantAccessRequirementsStateResponse.Failure);
Builder.createAndAttachToType(RetrieveInstantAccessRequirementsStateResponse.Failure);
/**
 * SOURCE ListDDSEligibleUnitsRequest @ squareup/inflows/service/external_instant_access_service.proto at 154:1
 */
export const ListDDSEligibleUnitsRequest = $root.lookupType('squareup.inflows.service.ListDDSEligibleUnitsRequest');
fixType(ListDDSEligibleUnitsRequest, {
  merchantToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ListDDSEligibleUnitsRequest);
/**
 * SOURCE DDSEligibleUnitInfo @ squareup/inflows/service/external_instant_access_service.proto at 158:1
 */
export const DDSEligibleUnitInfo = $root.lookupType('squareup.inflows.service.DDSEligibleUnitInfo');
fixType(DDSEligibleUnitInfo);
Builder.createAndAttachToType(DDSEligibleUnitInfo);
/**
 * SOURCE IntegrationToOptInStatus @ squareup/inflows/service/external_instant_access_service.proto at 161:3
 */
DDSEligibleUnitInfo.IntegrationToOptInStatus = $root.lookupType('squareup.inflows.service.DDSEligibleUnitInfo.IntegrationToOptInStatus');
fixType(DDSEligibleUnitInfo.IntegrationToOptInStatus);
Builder.createAndAttachToType(DDSEligibleUnitInfo.IntegrationToOptInStatus);
/**
 * SOURCE ListDDSEligibleUnitsResponse @ squareup/inflows/service/external_instant_access_service.proto at 173:1
 */
export const ListDDSEligibleUnitsResponse = $root.lookupType('squareup.inflows.service.ListDDSEligibleUnitsResponse');
fixType(ListDDSEligibleUnitsResponse);
Builder.createAndAttachToType(ListDDSEligibleUnitsResponse);
/**
 * SOURCE Success @ squareup/inflows/service/external_instant_access_service.proto at 179:3
 */
ListDDSEligibleUnitsResponse.Success = $root.lookupType('squareup.inflows.service.ListDDSEligibleUnitsResponse.Success');
fixType(ListDDSEligibleUnitsResponse.Success);
Builder.createAndAttachToType(ListDDSEligibleUnitsResponse.Success);
/**
 * SOURCE Failure @ squareup/inflows/service/external_instant_access_service.proto at 183:3
 */
ListDDSEligibleUnitsResponse.Failure = $root.lookupType('squareup.inflows.service.ListDDSEligibleUnitsResponse.Failure');
fixType(ListDDSEligibleUnitsResponse.Failure);
Builder.createAndAttachToType(ListDDSEligibleUnitsResponse.Failure);
/**
 * SOURCE OptOutOfInstantAccessProgramRequest @ squareup/inflows/service/external_instant_access_service.proto at 188:1
 */
export const OptOutOfInstantAccessProgramRequest = $root.lookupType('squareup.inflows.service.OptOutOfInstantAccessProgramRequest');
fixType(OptOutOfInstantAccessProgramRequest, {
  unitToken: {
    notEmpty: true
  },
  platform: {
    required: true
  }
});
Builder.createAndAttachToType(OptOutOfInstantAccessProgramRequest);
/**
 * SOURCE OptOutOfInstantAccessProgramResponse @ squareup/inflows/service/external_instant_access_service.proto at 193:1
 */
export const OptOutOfInstantAccessProgramResponse = $root.lookupType('squareup.inflows.service.OptOutOfInstantAccessProgramResponse');
fixType(OptOutOfInstantAccessProgramResponse);
Builder.createAndAttachToType(OptOutOfInstantAccessProgramResponse);
/**
 * SOURCE Success @ squareup/inflows/service/external_instant_access_service.proto at 199:3
 */
OptOutOfInstantAccessProgramResponse.Success = $root.lookupType('squareup.inflows.service.OptOutOfInstantAccessProgramResponse.Success');
fixType(OptOutOfInstantAccessProgramResponse.Success);
Builder.createAndAttachToType(OptOutOfInstantAccessProgramResponse.Success);
/**
 * SOURCE Failure @ squareup/inflows/service/external_instant_access_service.proto at 201:3
 */
OptOutOfInstantAccessProgramResponse.Failure = $root.lookupType('squareup.inflows.service.OptOutOfInstantAccessProgramResponse.Failure');
fixType(OptOutOfInstantAccessProgramResponse.Failure);
Builder.createAndAttachToType(OptOutOfInstantAccessProgramResponse.Failure);
/**
 * SOURCE OptInToInstantAccessProgramRequest @ squareup/inflows/service/external_instant_access_service.proto at 206:1
 */
export const OptInToInstantAccessProgramRequest = $root.lookupType('squareup.inflows.service.OptInToInstantAccessProgramRequest');
fixType(OptInToInstantAccessProgramRequest, {
  unitToken: {
    notEmpty: true
  },
  platform: {
    required: true
  },
  optInMechanism: {
    required: true
  }
});
Builder.createAndAttachToType(OptInToInstantAccessProgramRequest);
/**
 * SOURCE OptInToInstantAccessProgramResponse @ squareup/inflows/service/external_instant_access_service.proto at 212:1
 */
export const OptInToInstantAccessProgramResponse = $root.lookupType('squareup.inflows.service.OptInToInstantAccessProgramResponse');
fixType(OptInToInstantAccessProgramResponse);
Builder.createAndAttachToType(OptInToInstantAccessProgramResponse);
/**
 * SOURCE Success @ squareup/inflows/service/external_instant_access_service.proto at 218:3
 */
OptInToInstantAccessProgramResponse.Success = $root.lookupType('squareup.inflows.service.OptInToInstantAccessProgramResponse.Success');
fixType(OptInToInstantAccessProgramResponse.Success);
Builder.createAndAttachToType(OptInToInstantAccessProgramResponse.Success);
/**
 * SOURCE Failure @ squareup/inflows/service/external_instant_access_service.proto at 222:3
 */
OptInToInstantAccessProgramResponse.Failure = $root.lookupType('squareup.inflows.service.OptInToInstantAccessProgramResponse.Failure');
fixType(OptInToInstantAccessProgramResponse.Failure);
Builder.createAndAttachToType(OptInToInstantAccessProgramResponse.Failure);
/**
 * SOURCE ExternalInstantAccessService @ squareup/inflows/service/external_instant_access_service.proto at 227:1
 */
export const ExternalInstantAccessService = $root.lookupService('squareup.inflows.service.ExternalInstantAccessService');